import React, { Component, useState } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, TouchableHighlight, FlatList, ActivityIndicator} from "react-native-web";


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function MenuModalMobile(props) {

    const handleClick = () => {

    }




    const onMenuItemPressed = (key) => {
        if (key === 'Home')
        {
           window.location = '/';
        }
        else if (key === 'About')
        {
           window.location = '/about';
        }
        else if (key === 'GetSP')
        {
           window.location = '/get-a-storrypage';
        }
        else if (key === 'LMC')
        {
           window.location = '/living-memory-of-congo';
        }
        else if (key === 'Help')
        {
           window.location = '/help';
        }
        else if (key === 'Women')
        {
           window.location = '/les-femmes';
        }
        else if (key === 'Principles')
        {
           window.location = '/principes-directeurs';
        }
        else if (key === 'Appel')
        {
           window.location = '/appel-a-l-action';
        }
        else if (key === 'Account_settings')
        {
           window.location = '/myaccount';
        }
        else if (key === 'Saveds')
        {
           window.location = '/saveditems';
        }
        else if (key === 'Courses')
        {
           window.location = '/mycourses';
        }
        else if (key === 'Payments')
        {
           window.location = '/payments';
        }
        else if (key === 'Signin')
        {
           window.location = '/signin';
        }
        else if (key === 'Signup')
        {
           window.location = '/signup';
        }
        else if (key === 'Signout')
        {
              localStorage.removeItem('storrypagejwtToken');
              localStorage.removeItem('storrypageUser');
              localStorage.removeItem('storrypageAfter');

              setTimeout(() => {
                 window.location = "/";
              },100);
        }
    }

    const setLocale = (lang) => {



           localStorage.setItem("language", lang);
           i18n.changeLanguage(lang);


    }


    const renderFooterComponent = () => {
     return (
       <div style={{marginTop: '40px'}}>
           <div style={{lineHeight: '55px', color: '#333', fontFamily: 'Roboto', fontSize: '18px'}}>
             {i18n.language == 'fr' &&
                <div style={{textAlign: 'center'}}><a href={void(0)} onClick={() => setLocale("en")} style={{color: '#0b49ff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={void(0)} onClick={() => setLocale("fr")} style={{color: '#0b49ff'}}>FR</a></div>
             }
             {i18n.language == 'en' &&
                <div style={{textAlign: 'center'}}><a href={void(0)} onClick={() => setLocale("en")} style={{color: '#0b49ff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={void(0)} onClick={() => setLocale("fr")} style={{color: '#0b49ff'}}>FR</a></div>
             }
           </div>
       </div>
     )
    }

    let dataVisitor;

    if (!props.isSignedin)
    {
        dataVisitor = [
          {key: 'Home', title: i18n.t('Home')},
          {key: 'About', title: i18n.t('About')},
          {key: 'GetSP', title: i18n.t('Get_a_storrypage')},
          {key: 'LMC', title: i18n.t('Living_memory_of_congo')},
          {key: 'Help', title: i18n.t('Help_center')},
          {key: 'Signin', title: i18n.t('signin')},
          {key: 'Signup', title: i18n.t('signup')}
        ];
    }
    else
    {
        dataVisitor = [
          {key: 'Home', title: i18n.t('Home')},
          {key: 'Account_settings', title: i18n.t('Account_settings')},
          {key: 'About', title: i18n.t('About')},
          {key: 'GetSP', title: i18n.t('Get_a_storrypage')},
          {key: 'LMC', title: i18n.t('Living_memory_of_congo')},
          {key: 'Help', title: i18n.t('Help_center')},
          {key: 'Saveds', title: i18n.t('Mysaveds')},
        //  {key: 'Courses', title: i18n.t('Mycourses')},
        //  {key: 'Payments', title: i18n.t('Payments')},
          {key: 'Signout', title: i18n.t('Signout')},
        ];
    }



    return (

          <div id="myNav" className="menu-modal-transl"
									style={{display: 'none', position: 'absolute', top: '70px', zIndex: 99999,
                     width: viewportWidth+'px', height:  viewportHeight+'px',
                         background: 'rgba(255, 255, 255, 0.8)', textAlign: 'center'}}>


                         <div style={{clear: 'both', height: '20px'}}/>


                         <FlatList data={dataVisitor}
                              showsHorizontalScrollIndicator={false}
                              ListFooterComponent={renderFooterComponent}
                              renderItem={({ item,index }) =>  (
                                <TouchableHighlight underlayColor="transparent" onPress={() => {onMenuItemPressed(item.key)}}>
                                  <View style={{flexDirection: 'row', height: 45,}}>

                                    {1===2 &&
                                      <View style={{width: 36, height: 60, marginLeft: 5}}>

                                         <View style={{width: 36, height: 60, justifyContent: 'center'}}>
                                           {item.key === 'Payments' &&
                                             <Image source={{uri: item.icon}} style={{width: 32, height: 32, marginLeft: 5}}/>
                                           }
                                           {item.key === 'Courses' &&
                                             <Image source={{uri: item.icon}} style={{width: 38, height: 38, marginLeft: 0}}/>
                                           }
                                           {item.key !== 'Payments' && item.key !== 'Courses' &&
                                              <Image source={{uri: item.icon}} style={{width: 36, height: 36, marginLeft: 0}}/>
                                            }
                                         </View>

                                     </View>
                                   }
                                     <View style={{height: 45, marginLeft: '30px', justifyContent: 'center'}}>
                                        <Text style={{color: '#0b49ff', fontWeight: 'bold', fontSize: '20px', textAlign: 'left'}}>{item.title}</Text>
                                     </View>
                                  </View>
                                </TouchableHighlight>
                              )}
                              keyExtractor={(item, index) => ''+index}
                              />



           </div>

    )

}
